import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

import Logo from '../../assets/complete-logo-invert.png';
import HeaderArrowIcon from '../../components/header-arrow-icon/header-arrow-icon.component';

import { HeaderDiv, HeaderContainer, LogoContainer, LogoImg, ArrowContainer } from './header.styles.jsx'
import './header.styles.scss';

const Header = () => {
  return (
    <Fragment>
      <HeaderDiv>
        <HeaderContainer>
          <LogoContainer>
            <LogoImg src={Logo} alt='logo' />
          </LogoContainer>
          <div className="nav__burguer">
            <div className="nav__burguer-line-1"></div>
            <div className="nav__burguer-line-2"></div>
            <div className="nav__burguer-line-3"></div> 
          </div>
        </HeaderContainer>
        <ArrowContainer>
          <HeaderArrowIcon />
        </ArrowContainer>
      </HeaderDiv>
      <Outlet />
    </Fragment>
  )
}

export default Header;